{
  "wave": {
    "name": "Wave",
    "description": "Paiement rapide via Wave",
    "instructions": "Vous recevrez une notification Wave pour confirmer le paiement",
    "ussd_prompt": "Composez *1* pour confirmer"
  },
  "orange_money": {
    "name": "Orange Money",
    "description": "Paiement via Orange Money",
    "instructions": "Composez #144# pour confirmer le paiement",
    "ussd_prompt": "Tapez votre code secret Orange Money"
  },
  "cash_on_delivery": {
    "name": "Paiement à la livraison",
    "description": "Payez en espèces à la réception de votre commande"
  },
  "status": {
    "pending": "En attente de paiement",
    "processing": "Traitement en cours",
    "confirmed": "Paiement confirmé",
    "failed": "Échec du paiement",
    "timeout": "Délai dépassé",
    "refunded": "Remboursé"
  },
  "errors": {
    "network": "Erreur de connexion. Vérifiez votre réseau.",
    "invalid_phone": "Numéro de téléphone invalide",
    "insufficient_funds": "Solde insuffisant",
    "provider_unavailable": "Service temporairement indisponible",
    "invalid_amount": "Montant invalide",
    "timeout": "Le délai de confirmation a expiré. Veuillez réessayer.",
    "unknown": "Une erreur inattendue est survenue"
  },
  "actions": {
    "retry": "Réessayer",
    "cancel": "Annuler le paiement",
    "change_method": "Changer de moyen de paiement"
  }
}
